export const removeDiacriticsAndNormalize = (str: string) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .toLocaleLowerCase()
    .split(' ')
    .join('-')
}

const cities = [
  { sk: 'Bratislava', en: 'Bratislava' },
  { sk: 'Košice', en: 'Košice' },
  { sk: 'Banská Bystrica', en: 'Banská Bystrica' },
  { sk: 'Žilina', en: 'Žilina' },
  { sk: 'Prešov', en: 'Prešov' },
  { sk: 'Poprad', en: 'Poprad' },
  { sk: 'Piešťany', en: 'Piešťany' },
  { sk: 'Bratislavský kraj', en: 'Bratislava Region' },
  { sk: 'Trnavský kraj', en: 'Trnava Region' },
  { sk: 'Nitriansky kraj', en: 'Nitra Region' },
  { sk: 'Žilinský kraj', en: 'Žilina Region' },
  { sk: 'Košický kraj', en: 'Košice Region' },
  { sk: 'Prešovský kraj', en: 'Prešov Region' },
  { sk: 'Trenčiansky kraj', en: 'Trenčín Region' },
  { sk: 'Banskobystrický kraj', en: 'Banská Bystrica Region' },
  { sk: 'Trnava', en: 'Trnava' },
  { sk: 'Nitra', en: 'Nitra' },
  { sk: 'Trenčín', en: 'Trenčín' },
  { sk: 'Zvolen', en: 'Zvolen' },
]

export const getCityName = (city: string) => {
  if (!city) return

  const normalizedInput = removeDiacriticsAndNormalize(city)

  for (const entry of cities) {
    const normalizedSk = removeDiacriticsAndNormalize(entry.sk)
    const normalizedEn = removeDiacriticsAndNormalize(entry.en)

    if (normalizedInput === normalizedSk || normalizedInput === normalizedEn) {
      return {
        sk: entry.sk,
        en: entry.en,
        normalizedSk,
        normalizedEn,
      }
    }
  }

  return null // keď sa nič nenašlo
}
